module.exports = __webpack_public_path__ + "img/pic1.8f7709c9.png";